export default __webpack_public_path__ + "static/media/Ahmad Beirkdar - Developer.3c6f1b5f.jpg";